import { NotificationService } from "@core/apis/notification.service";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import {
  loadNotifications,
  loadNotificationsFailure,
  loadNotificationsSuccess,
  loadUnreadCount,
  loadUnreadCountFailure,
  loadUnreadCountSuccess,
  markAllNotificationsAsRead,
  markAllNotificationsAsReadFailure,
  markAllNotificationsAsReadSuccess,
  markNotificationAsRead,
  markNotificationAsReadFailure,
  markNotificationAsReadSuccess,
} from "./notifications.actions";

@Injectable()
export class NotificationsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly notificationService: NotificationService
  ) {}

  loadNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadNotifications),
      switchMap(({ query }) =>
        this.notificationService.getNotifications(query).pipe(
          map((notifications) => loadNotificationsSuccess({ notifications })),
          catchError((error) => of(loadNotificationsFailure({ error: error.message })))
        )
      )
    )
  );

  loadUnreadCount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUnreadCount),
      switchMap(({ businessId }) =>
        this.notificationService.getUnreadCount(businessId).pipe(
          map((response) => loadUnreadCountSuccess({ count: response.count })),
          catchError((error) => of(loadUnreadCountFailure({ error: error.message })))
        )
      )
    )
  );

  markNotificationAsRead$ = createEffect(() =>
    this.actions$.pipe(
      ofType(markNotificationAsRead),
      switchMap(({ notificationId }) =>
        this.notificationService.markAsRead(notificationId).pipe(
          map((notification) => markNotificationAsReadSuccess({ notification })),
          catchError((error) => of(markNotificationAsReadFailure({ error: error.message })))
        )
      )
    )
  );

  markAllNotificationsAsRead$ = createEffect(() =>
    this.actions$.pipe(
      ofType(markAllNotificationsAsRead),
      switchMap(({ businessId }) =>
        this.notificationService.markAllAsRead(businessId).pipe(
          map(() => markAllNotificationsAsReadSuccess()),
          catchError((error) => of(markAllNotificationsAsReadFailure({ error: error.message })))
        )
      )
    )
  );
}
